import React, { useContext, useState, useEffect, useRef } from "react";

import { ShareContext } from "../../context/ShareContext";

import { time } from "../../data/time";
import {
  useNavigate,
  useLocation,
  Link,
  useParams,
  useSearchParams,
} from "react-router-dom";
import * as Constants from "../../constants";
import BackLoader from "../../components/backloader";

import moment from "moment";
import JisPreparePdf from "../../components/core/preparepdf";
import DynamicIcon from "../../components/dynamicicon";
import JisPrepareTemplate from "../../components/core/preparetemplate";
import JisButton from "../../components/controls/jisButton";
import JisDialogForm from "../../components/formdialog";
import LegalCounselorJisPrepareTemplate from "../../components/core/legalCounselorPrepareTemplate";
import { RefreshCcw } from "lucide-react";

function PrepareAffidavit(props) {
  const { setWhichUpload, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const { docid } = useParams();
  const { role, type } = useParams();
  const [searchParams] = useSearchParams();

  const amount = searchParams.get("amount");
  const ref = searchParams.get("ref");

  const isLegal = role == "user" ? true : false;

  const canChangeTemplate =
    ["admin", "customer", "edm"].includes(profile.role.name.toLowerCase()) &&
    type === "template";

  const [schedule, setSchedule] = useState({});
  //  var profileid=Constants.isServerEnv? Constants.getCookie("profilename"):'seniola1' ;
  const [info, setInfo] = useState({});
  const url = `${Constants.apiUrl}/filing/AffidavitDocs/${docid}`;

  const [isDialog, setIsDialog] = useState(false);
  const [doc, setDocument] = useState({ uplines: [], uplinesigns: [] });
  const [currectdoc, setCurrentDoc] = useState({ upline: null, filenames: [] });
  const [uplineIndex, setUplineIndex] = useState(0);
  const [imgIndex, setImageIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [posPoint, setPosPoint] = useState({}); //this is for items that are yet added passport 1, Seal 2, Signature 3  {x--cord,y - cord,show bool,docid  instype, imgurl}
  const [isPaid, setIsPaid] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [isSaved, setIsSaved] = useState(false);
  const [cashier_seal, setCashierSeal] = useState("");

  //load documents first, then load one by one
  const [posId, setPosId] = useState(0); //this is the main guy that is doing the selection
  const [dstart, setDStart] = useState({ isDragging: false });
  const [imgs, setImgs] = useState([]);
  const [activeFile, setActiveFile] = useState({});

  const [isDocVerified, setIsDocVerified] = useState(false);
  const [imgPrev, setImgPrev] = useState({ data: "", type: "", open: false });
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "" });
  const [prompt, setPrompt] = useState({
    open: false,
    title: "",
    subtitle: "",
  });
  const tempUrl = `${Constants.apiUrl}/setup/templates/affidavit`;
  const [template, setTemplates] = useState([]);
  const affidavit_search_prefix = "LSJ/HC/AFF";

  var pageRef = useRef(null);
  const navigate = useNavigate();
  const onOk = () => {
    setAlert({ ...alert, open: false });
  };
  const onGotoDashboard = () => {
    setAlert({ ...alert, open: false });
    navigate("/dashboard");
  };
  const confirmCaseDoc = () => {
    navigate("/upload/documents");
    setWhichUpload("Third");
  };

  useEffect(() => {
    onLoad();
    LoadTemplates();
  }, [docid]);

  useEffect(() => {
    role === "cfo" &&
      fetch(`${Constants.apiUrl}/filing/DocumentView/${docid}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((r) => r.json())
        .then((d) => {
          console.log("DocumentView response", d);
          if (d?.isVerified) setIsDocVerified(true);
        })
        .catch((e) => console.error("DocumentView fetch failed", e));
  }, [docid, role]);

  const onLoadTemplate = async (templateId) => {
    const url = `${Constants.apiUrl}/setup/templates/${templateId}/details`;
    console.log(`Loading template from url: ${url}`);
    try {
      setIsLoading(true);
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setIsLoading(false);
      console.log("template data", data);
      if (data.code == 0) {
        // Create a template structure that mimics the upline structure
        const templateUpline = {
          id: templateId,
          documentTitle: data.template.title,
          uplineType: "template",
          html: data.template.html,
          // Add other properties as needed
        };
        setCurrentDoc({
          upline: templateUpline,
          filenames: [],
          template: data.template,
        });
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const handleSelect = (e) => {
    const selectedValue = e.target.value;
    console.log("Selected document:", selectedValue);
    if (selectedValue) {
      // Check if it's a template ID (from the template dropdown)
      const selectedTemplate = template.find((t) => t.id == selectedValue);
      if (selectedTemplate) {
        // It's a template, use the template endpoint
        onLoadTemplate(selectedValue);
      } else {
        // It's an upline document, use the existing endpoint
        onCurrentDoc(selectedValue, "upline");
      }
    }
  };

  useEffect(
    () => {
      if (!pageRef.current) {
        // we do not initialize the observer unless the ref has
        // been assigned
        return;
      }

      // we also instantiate the resizeObserver and we pass
      // the event handler to the constructor
      const resizeObserver = new ResizeObserver(() => {
        console.log("in resize observer ");
        const divPos = pageRef.current.getBoundingClientRect();
        const start = {
          initialX: divPos.x,
          initialY: divPos.y,
        };
        console.log("at use effect calculate init position");
        console.log(start);

        setDStart(start);
      });

      resizeObserver.observe(pageRef.current);

      return function cleanup() {
        resizeObserver.disconnect();
      };
    },
    // only update the effect if the ref element changed
    [pageRef.current],
  );

  const onLoad = async () => {
    //for account registration
    console.log(`the calling url ${url}`);
    try {
      setIsLoading(true);
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setIsLoading(false);
      if (data.code == 0) {
        setDocument(data);
        setIsPaid(data.doc.isPaid);
        console.log(data.doc.isPaid, " data doc is paid");

        //load current first item
        const division = Constants.getItemById(
          frequentData?.divisions,
          data.doc?.divisionId,
        )?.title;
        var _info = { division, type: "affidavit" };
        setInfo(_info);
        onCurrentDoc(data.uplines[0].id, "upline");
        setDocument({ ...data.doc, uplines: data.uplines });
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const onCurrentDoc = async (id, ftype) => {
    //doctype=upline always this one
    //for account registration DocumentView
    const url = `${Constants.apiUrl}/filing/singlefile/${id}/${ftype}`;
    setCashierSeal(
      `${Constants.rooturl}/resources/special/cashier_seal_${id}.png`,
    );
    console.log(`the calling url ${url}`);
    try {
      setIsLoading(true);
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setIsLoading(false);
      console.log("specific document");
      console.log(data);
      if (data.code == 0) {
        setCurrentDoc({ ...data }); //filenames[] and upline
        if (data.upline.uplineType == "template") {
          console.log("oncurrentdoc is template ooo");
        }
      } else if (data.code == 1) {
        setCurrentDoc({ ...data }); //this one has template and upline
        if (data.upline.uplineType == "template") {
          console.log("oncurrentdoc is template ooo");
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const onNextFile = () => {
    if (imgs.length > 0 && !isSaved) {
      setAlert({
        ...alert,
        title: "Save Instrument",
        open: true,
        subtitle: `Please save the instrument before you see another document or you drag it off the screen before you continue.`,
        onOk,
      });
      return;
    }

    setIsSaved(false);
    var size = doc.uplines.length;
    setPageIndex(0);
    setImgs([]);
    setPosPoint({});

    if (uplineIndex < size - 1) {
      var a = uplineIndex + 1;
      setUplineIndex(a);
      setImageIndex(0);
      onCurrentDoc(doc.uplines[a].id, "upline");
    } else {
      // alert('What you seeing is the last file');
      setAlert({
        open: true,
        title: "Document",
        subtitle: "What you seeing is the last file",
        onOk,
      });
    }
  };

  const onPrevFile = () => {
    if (imgs.length > 0 && !isSaved) {
      setAlert({
        ...alert,
        title: "Save Instrument",
        open: true,
        subtitle: `Please save the instrument before you see another document or you drag it off the screen before you continue.`,
        onOk,
      });
      return;
    }
    setIsSaved(false);
    console.log(uplineIndex);
    setPageIndex(0);
    setImgs([]);
    setPosPoint({});
    if (uplineIndex > 0) {
      var a = uplineIndex - 1;
      setUplineIndex(a);
      setImageIndex(0);
      onCurrentDoc(doc.uplines[a].id, "upline");
    } else {
      //alert('What you seeing is the first file');
      setAlert({
        open: true,
        title: "Document",
        subtitle: "What you seeing is the first file",
        onOk,
      });
    }
  };

  const onRefreshUpline = () => {
    onCurrentDoc(currectdoc.upline.id, "upline");
  };
  //end image rendered

  const onInstumentAppended = (e) => {
    //after saving of instrument, this is what you get
    if (e.code == 0) {
      //saved already
      setImgPrev({ ...imgPrev, open: false });
      setIsSaved(true);
    }
  };

  const onSaveSchedule = (e) => {
    e.preventDefault();
    console.log(schedule);
    var sch = {
      docid: docid,
      zoomLink: schedule.zoom,
      scheduledBy: profile.username,
      scheduleDate: schedule.date + " " + schedule.time,
    };

    const uploadurl = `${Constants.apiUrl}/filing/e-swearing/schedule/${docid}`;

    // Sending the FormData using fetch
    setIsLoading(true);
    fetch(uploadurl, {
      method: "POST",
      body: JSON.stringify(sch),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          //saved already
          //first upldate the row and show dialog box

          setSchedule({});

          setAlert({
            open: true,
            title: "Schedule an Appointment",
            subtitle: "Meeting Schedule is successful",
          });
          setIsDialog(false);
          // navigate(-1); //going back
          navigate(`/cfo-affidavits`);
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  };
  const retrieveDocYear = () => {
    return currectdoc?.upline?.uploadDate == null
      ? moment(new Date()).format("YYYY")
      : moment(currectdoc?.upline?.uploadDate).format("YYYY");
  };

  const LoadTemplates = () => {
    setIsLoading(true);
    fetch(tempUrl, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          setTemplates(data.templates);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const goToNextIncomplete = () => {
    if (!doc || !doc.uplines || doc.uplines.length === 0) {
      setAlert({
        open: true,
        title: "Next Document",
        subtitle: "No documents available",
        onOk,
      });
      return;
    }

    const size = doc.uplines.length;
    // try forward from current index
    let foundIndex = -1;
    for (let i = uplineIndex + 1; i < size; i++) {
      const upl = doc.uplines[i] || {};
      // treat as complete if any of these flags are true
      const completed = upl.isCompleted === true;
      if (!completed) {
        foundIndex = i;
        break;
      }
    }

    // if not found ahead, do a full scan from start (skip current)
    if (foundIndex === -1) {
      for (let i = 0; i < size; i++) {
        if (i === uplineIndex) continue;
        const upl = doc.uplines[i] || {};
        const completed = upl.isCompleted === true;
        if (!completed) {
          foundIndex = i;
          break;
        }
      }
    }

    if (foundIndex === -1) {
      setAlert({
        open: true,
        title: "Next Document",
        subtitle: "No more incomplete documents found",
        onOk,
      });
      return;
    }

    // navigate to that upline
    setUplineIndex(foundIndex);
    setImageIndex(0);
    setIsSaved(false);
    onCurrentDoc(doc.uplines[foundIndex].id, "upline");
  };

  return (
    <div className="view-doc">
      <div className="body" style={{ width: "100%" }}>
        <div className="top-nav">
          <div className="left-top">
            <div className="top">
              <h3>Prepare Affidavit Document</h3>
              <div className="icon" onClick={onRefreshUpline}>
                <RefreshCcw className="icon" />
                {/* refresh */}
              </div>
            </div>
          </div>
          {/* <p className="nav-status">
            {!isLegal && (
              <JisButton icon="schedule" onClick={() => setIsDialog(true)}>
                {doc.schedule == null ? "Schedule" : "Reshedule"}{" "}
              </JisButton>
            )}
          </p> */}
        </div>
        <div className="summary_wrapper">
          {console.log(currectdoc, "test")}
          <div className="summary">
            <div>
              <strong>Affidavit ID</strong>
              <br />
              {currectdoc?.upline?.docRef}
            </div>
            <div>
              <strong>Number of Documents</strong>
              <br /> {doc?.uplines.length}
            </div>
            <div>
              <strong>Scheduled for e-Swearing</strong>
              <br />
              {doc.schedule == null ? "No" : "Yes"}
            </div>

            {doc.schedule != null && (
              <>
                <div>
                  <strong>e-Swearing Schedule Date</strong>
                  <br />{" "}
                  {doc.schedule == null
                    ? "N/A"
                    : Constants.formatDate(doc.schedule)}
                </div>
                <div>
                  <strong>e-Swearing Schedule Time</strong>
                  <br />
                  {doc.schedule == null
                    ? "N/A"
                    : Constants.formatTime(doc.schedule)}{" "}
                </div>
                <div>
                  <strong>Zoom Link</strong>
                  <br />
                  {doc.zoomLink != null && (
                    <a href={doc.zoomLink} target="_blank" rel="noreferrer">
                      {doc.zoomLink}
                    </a>
                  )}{" "}
                </div>
              </>
            )}
          </div>
          <div className="document-navigation">
            <button onClick={onPrevFile} className="planred">
              Previous
            </button>
            <div className="namedoc">
              {isLegal && (!isPaid || canChangeTemplate) ? (
                <select
                  id="documentSelect"
                  value={currectdoc.upline?.id || ""}
                  onChange={(e) => handleSelect(e)}
                >
                  <option value="">{currectdoc.upline?.documentTitle}</option>
                  {template.map((tem, index) => (
                    <option key={index} value={tem.id}>
                      {tem.title}
                    </option>
                  ))}
                </select>
              ) : (
                <p>{currectdoc.upline?.documentTitle}</p>
              )}
            </div>
            <button onClick={onNextFile} className="planred">
              Next
            </button>
          </div>
        </div>

        {currectdoc?.upline != null &&
          currectdoc.upline.uplineType != "template" && (
            <JisPreparePdf
              pdfdoc={currectdoc}
              docInfo={info}
              isLegal={isLegal}
              docUploadId={currectdoc?.upline.docUploadId}
              onInstumentAppended={onInstumentAppended}
              doctype="affidavit"
              scheduleButtonText={
                doc.schedule == null ? "Schedule Case" : "Reschedule Case"
              }
              onGoToNextIncomplete={goToNextIncomplete}
              onSchedule={() => setIsDialog(true)}
              isPaid={isPaid}
              isDocVerified={isDocVerified}
            />
          )}
        {currectdoc?.upline != null &&
          currectdoc.upline.uplineType == "template" &&
          (isLegal ? (
            <LegalCounselorJisPrepareTemplate
              templatedoc={currectdoc}
              docInfo={info}
              isPaid={isPaid}
              isLegal={isLegal}
              onInstumentAppended={onInstumentAppended}
              scheduleButtonText={
                doc.schedule == null ? "Schedule Case" : "Reschedule Case"
              }
              doctype="affidavit"
              onSchedule={() => setIsDialog(true)}
              isCurrentDocCommissioned={currectdoc.upline?.isCompleted}
            />
          ) : (
            <JisPrepareTemplate
              templatedoc={currectdoc}
              docInfo={info}
              isLegal={isLegal}
              onInstumentAppended={onInstumentAppended}
              scheduleButtonText={
                doc.schedule == null ? "Schedule Case" : "Reschedule Case"
              }
              doctype="affidavit"
              onSchedule={() => setIsDialog(true)}
              onGoToNextIncomplete={goToNextIncomplete}
              isPaid={isPaid}
              isDocVerified={isDocVerified}
              isCurrentDocCommissioned={currectdoc.upline?.isCompleted}
              isCfo={role === "cfo"}
            />
          ))}
      </div>
      {isDialog && (
        <JisDialogForm title="Schedule" onClose={() => setIsDialog(false)}>
          <form onSubmit={onSaveSchedule}>
            <div>
              <div className="input-group">
                <label> Zoom Link</label>
                <div className="input-wrapper">
                  <DynamicIcon iname="chair_alt" />
                  <input
                    type="url"
                    placeholder="Zoom Link"
                    value={schedule.zoom}
                    onChange={(e) =>
                      setSchedule({ ...schedule, zoom: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="input-group">
                <label> Zoom meeting date</label>
                <div className="input-wrapper">
                  <DynamicIcon iname="chair_alt" />
                  <input
                    type="date"
                    placeholder="Zoom meeting date"
                    value={schedule.date}
                    onChange={(e) =>
                      setSchedule({ ...schedule, date: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="input-group">
                <label> Zoom meeting time</label>
                <div className="input-wrapper">
                  <DynamicIcon iname="chair_alt" />
                  <input
                    type="time"
                    placeholder="Zoom meeting time"
                    value={schedule.time}
                    onChange={(e) =>
                      setSchedule({ ...schedule, time: e.target.value })
                    }
                  />
                </div>
              </div>

              <div>
                <JisButton icon="check_circle" type="submit">
                  Schedule Appointment
                </JisButton>
                {/* <JisButton icon="close" variant={'outline'} onClick={() => setIsDialog(false)}>Cancel</JisButton> */}
              </div>
            </div>
          </form>
        </JisDialogForm>
      )}

      <BackLoader open={isLoading} />
    </div>
  );
}

export default PrepareAffidavit;
